import {useMemo} from 'react';
import {
  ChartOptions,
} from 'chart.js';
import { originalColors } from '../constants/originalColors';
import {MongoDBMonthlyCostData } from '../constants/types';
import { PanelBottomClose } from 'lucide-react';


export const useMongoDBMonthlyCostOptions = (chartRef: any, fullDataPoints: { month: string; [env: string]: number | string }[]): ChartOptions<'bar'> =>
  useMemo(() => ({    
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 900 },
    plugins: {
      legend: { display: true, labels: { font: { family: "'Inter', sans-serif", size: 14 } }, position: 'bottom', padding: { top: 10, bottom: 10 } },
      title: {
        display: true,
        text: 'AWS Monthly Cost - MongoDB',
        font: {
          family: "'Inter', sans-serif",
          size: 16,
          weight: 550,
        },
        padding: {
        bottom: 30,  // <-- Add bottom padding here to create gap
        },
      },
      datalabels: {
        color: '#899093',
        align: 'top',
        anchor: 'end',
        font: {
          family: "'Inter', sans-serif",
          size: 12,
          weight: 'bold',
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Month',
          font: { family: "'Inter', sans-serif", size: 14 },
        },
        ticks: { font: { family: "'Inter', sans-serif", size: 14 }, },
        grid: { display: false},
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Monthly Cost ($)',
          font: { family: "'Inter', sans-serif", size: 14 },
        },
        ticks: { font: { family: "'Inter', sans-serif", size: 14, } },
        grid: {color: function (context) {
            return context.index % 2 === 0 ? '#e5e7eb' : 'transparent';
          },
        }, 
      },
    },
  }), [chartRef, fullDataPoints.length]);

export const useMongoDBExpandedMonthlyCostOptions = (expandedChartRef: any, graphData: MongoDBMonthlyCostData[], fullLabels: string[], fullDataPoints: { month: string; [env: string]: number | string }[], hasConfirmed: boolean): ChartOptions<'bar'> => {
    let filteredDataPoints:{ month: string; [env: string]: number | string }[] = [];

    if (hasConfirmed && graphData) 
    {
      filteredDataPoints = graphData.map(item => ({ month: item.month, ...item.cost }))
    } 
    const baseOptions = useMongoDBMonthlyCostOptions(expandedChartRef, fullDataPoints);

  return {
    ...baseOptions,
  };
};
